var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBenchmarkComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.61 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #43a12a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    className: "cls-1",
    d: "M15.81,3.75c-6.35,0-11.5,5.15-11.5,11.5s5.15,11.5,11.5,11.5,11.5-5.15,11.5-11.5S22.16,3.75,15.81,3.75M22.65,13.57l-7.02,7.02c-.68.68-1.79.68-2.47,0,0,0,0,0,0,0l-4.2-4.19c-.68-.68-.68-1.79,0-2.47,0,0,0,0,0,0l.13-.13c.68-.68,1.79-.68,2.47,0l2.83,2.83,5.65-5.65c.68-.68,1.79-.68,2.47,0,0,0,0,0,0,0l.13.13c.68.68.68,1.79,0,2.47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBenchmarkComplete);
export default __webpack_public_path__ + "static/media/New Benchmark Complete.c66179e5431a4406b25cd96a7c2a4bfe.svg";
export { ForwardRef as ReactComponent };